import { render, staticRenderFns } from "./AreaHistory.vue?vue&type=template&id=7ce2e6bc&scoped=true"
import script from "./AreaHistory.vue?vue&type=script&lang=js"
export * from "./AreaHistory.vue?vue&type=script&lang=js"
import style0 from "./AreaHistory.vue?vue&type=style&index=0&id=7ce2e6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce2e6bc",
  null
  
)

export default component.exports